"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networkToSrc = exports.defer = void 0;
const types_1 = require("./types");
const defer = () => {
    // dummy value for typescript
    let deferred = { resolve: (res) => { }, reject: (err) => { } };
    // get promise and extract resolve/reject into d
    const promise = new Promise((resolve, reject) => { deferred = { resolve, reject }; });
    return { deferred, promise };
};
exports.defer = defer;
const networkToSrc = (network) => {
    switch (network) {
        case types_1.Networks.mainnet:
            return 'https://wallet.kukai.app';
        case types_1.Networks.ghostnet:
            return 'https://ghostnet.kukai.app';
        case types_1.Networks.ithacanet:
            return 'https://ithacanet.kukai.app';
        case types_1.Networks.jakartanet:
            return 'https://jakartanet.kukai.app';
        case types_1.Networks.kathmandu:
            return 'https://kathmandu.kukai.app';
        case types_1.Networks.dev:
            return 'https://ichabod-dev.kukai.app';
        case types_1.Networks.local:
            return 'http://localhost:4200';
        default:
            return network;
    }
};
exports.networkToSrc = networkToSrc;
